module.exports = __webpack_public_path__ + "static/img/2813_phase_function_Paper_PointsHejduk_Prediction.8c50978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2813_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Soza
// module chunks = 0